import { render, staticRenderFns } from "./VInventoryAttributeCreateModal.vue?vue&type=template&id=4ab0d88a"
import script from "./VInventoryAttributeCreateModal.vue?vue&type=script&lang=js"
export * from "./VInventoryAttributeCreateModal.vue?vue&type=script&lang=js"
import style0 from "./VInventoryAttributeCreateModal.vue?vue&type=style&index=0&id=4ab0d88a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports